import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UserServiceCard2Component } from '@core/components/service-card/user-service-card-2.component';

@Component({
  selector: 'app-user-service-card',
  templateUrl: './user-service-card.component.html',
  styleUrls: ['../../../core/components/service-card/user-service-card-2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
}) // TODO вынужденная мера. Из-за цмклических зависимостей нельзя использовать UserServiceCard2Component
export class UserServiceCardComponent extends UserServiceCard2Component {
  public goSignup(e) {
    if (!this.canSignup) {
      return;
    }
    this.selected.emit(true);
  }
}
